// height of the global header in pixels
// These values should match what we have for the tailwind:
//  classes in GlobalHeader.tsx: h-[56px] lg:h-[123px]
export const GLOBAL_HEADER_HEIGHT_DESKTOP_PX = 123
export const SUBHEADER_HEIGHT_DESKTOP_PX = 51
export const GLOBAL_HEADER_HEIGHT_MOBILE_PX = 56
export const SUBHEADER_HEIGHT_MOBILE_PX = 48
export const PAGE_SPECIFIC_SUBHEADER_HEIGHT_PX = 66
